import React from "react";

import "../css/PopupCrossSellingLineItem.css";

export default ({ product, total }) => {
  return (
    <div className="popup-row popup-row-crosssellingline-item">
      <span className="popup-row-crosssellingline-item-description">
        {product}
      </span>
      <span>{total}</span>
    </div>
  );
};
